import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { request, ApiResponse } from 'services/api/base';
import { FaFileAlt } from 'react-icons/fa';

interface Props {
    reportId: number;
    onClose: () => void;
}

interface State {
    htmlContent: string;
    isLoading: boolean;
    error: string | null;
}

export class AiReportViewerModal extends React.Component<Props, State> {
    public state: State = {
        htmlContent: '',
        isLoading: true,
        error: null
    };

    public async componentDidMount() {
        try {
            // Your standard request utility handles attaching JWT Bearer tokens natively!
            const response: ApiResponse = await request({
                method: 'GET',
                url: `/ailab/view-report/${this.props.reportId}`
            });

            if (response.isSuccess) {
                // If the controller returns raw string data instead of json, extract it here
                this.setState({ htmlContent: response.data, isLoading: false });
            } else {
                this.setState({ error: response.getError() || 'Failed to pull report records.', isLoading: false });
            }
        } catch (err: any) {
            this.setState({ error: err.message, isLoading: false });
        }
    }

    public render() {
        const { htmlContent, isLoading, error } = this.state;

        return (
            <Modal centered={true} show={true} onHide={this.props.onClose} size="lg" backdrop="static">
                <Modal.Header closeButton={true}>
                    <Modal.Title className="d-flex align-items-center">
                        <FaFileAlt className="me-2 text-success" /> Historical Analysis Document Report Viewer
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4" style={{ backgroundColor: '#f8f9fa', minHeight: '300px', maxHeight: '70vh', overflowY: 'auto' }}>
                    
                    {isLoading && (
                        <div className="d-flex flex-column align-items-center justify-content-center py-5">
                            <Spinner animation="border" variant="success" className="mb-3" />
                            <h6 className="fw-bold text-dark">Extracting Pipeline Analysis Records...</h6>
                        </div>
                    )}

                    {error && (
                        <div className="alert alert-danger border-0 shadow-sm">
                            <h6 className="fw-bold">Report Retrieval Mismatch</h6>
                            <p className="small mb-0">{error}</p>
                        </div>
                    )}

                    {!isLoading && !error && (
                        <div className="bg-white p-4 rounded border shadow-sm markdown-body">
                            <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
                        </div>
                    )}

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="fw-bold" onClick={this.props.onClose}>
                        CLOSE VIEW
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default AiReportViewerModal;